// Soft, deterministic avatar with initials — used when a counselor has no photo.
const PALETTE = [
  ["#A73C35", "#FDFBF7"], // mindora red on beige
  ["#3A4A3B", "#F4EFE6"], // forest
  ["#7A5C3A", "#FDFBF7"], // bronze
  ["#5C4A6E", "#F4EFE6"], // plum
  ["#2C5560", "#FDFBF7"], // ink-teal
  ["#8B5A2B", "#FDFBF7"], // umber
  ["#4A5D8B", "#F4EFE6"], // dusk blue
];

function hashIndex(str, mod) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h % mod;
}

function initials(name = "") {
  const parts = name.replace(/^Dr\.\s*/i, "").trim().split(/\s+/);
  if (parts.length === 0) return "·";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function InitialsAvatar({ name, className = "", size = "full", testId }) {
  const idx = hashIndex(name || "·", PALETTE.length);
  const [bg, fg] = PALETTE[idx];
  return (
    <div
      data-testid={testId}
      className={`flex items-center justify-center font-serif select-none ${className}`}
      style={{
        background: `linear-gradient(135deg, ${bg} 0%, ${bg}cc 100%)`,
        color: fg,
        width: size === "full" ? "100%" : size,
        height: size === "full" ? "100%" : size,
        letterSpacing: "0.05em",
      }}
    >
      <span style={{ fontSize: size === "full" ? "clamp(2.5rem, 6vw, 4rem)" : `calc(${typeof size === "string" ? size : size + "px"} * 0.42)` }}>
        {initials(name)}
      </span>
    </div>
  );
}
